module.exports = __webpack_public_path__ + "static/img/canberra.d383398.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/canberra.jpg
// module id = EXXa
// module chunks = 1